<template>
  <div style="height: 100%;">
    <!-- <div class="head" @click="$router.push('/me')">
      <img
        src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F0159315f8ea34911013f31104bf9b8.jpg%401280w_1l_2o_100sh.jpg&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1666144151&t=8756aca2b24941c241c18389c4565263"/>
    </div> -->
    <van-sticky>
      <div class="one" v-if="ReportInfos.length > 0">
          <div class="personal_im">
            <div class="name">{{ CloudImagePatientInfo.Name }}</div>
            <div class="gender">{{ GetSexText(CloudImagePatientInfo.Sex) }}</div>
            <div class="age">{{ GetAgeText(CloudImagePatientInfo.Birthday) }}</div>
          </div>
      </div>
    </van-sticky>
    <div class="reportList">
      <div v-for="(item, index) in UIReportInfos" :key="index" class="conter_bj">
        <h2>{{ item.CheckDate }}</h2>
        <div class="box" v-for="(report, i) in item.Reports" :key="i" @mousedown="handleReportInfoScan(report)">
          <div class="left">
            {{ moment(report.CheckDate).format('MM-DD') }}
          </div>
          <div class="right">
            <p>{{ report.HospitalName }}</p>
            <p>
              <span>{{ report.PatientName }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>{{ report.PatientSex }}&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>{{ report.PatientAge }}</span>
            </p>
            <h3>
              <span>{{ report.StudyTypeName }}</span>
              <span>{{ report.StudyItemName }}</span>
            </h3>
          </div>
        </div>
      </div>
      <van-loading type="spinner" class="loading" v-show="loadingSohw" />
    </div>
  </div>
</template>

<script>
import { GetPatientCloudReportInfos } from '@/api/CloudFilmService'
import {
  SetReportInfo,
  SetIsShowReportListBtn,
  SetIsShowShareBtn,
  GetCloudImagePatientInfo,
  GetPhoneNum,
} from '../../utils/cacheUtils'
import { GetAgeText, GetSexText } from '../../utils/common'
export default {
  name: 'ReportListView',
  data() {
    return {
      ReportInfos: [],
      PhoneNum: '',
      loadingSohw: true,
      UIReportInfos: [],
      CloudImagePatientInfo: {},
    }
  },
  mounted() {
    this.getPatientCloudReportInfos()
    this.CloudImagePatientInfo = GetCloudImagePatientInfo()
  },

  methods: {
    getPatientCloudReportInfos() {
      //先根据电话号码查询报告列表，如果只有一天报告时 自动跳转到报告浏览界面
      this.PhoneNum = GetPhoneNum()
      GetPatientCloudReportInfos({ telephone: this.PhoneNum })
        .then((resp) => {
          if (resp.Success && resp.Result && resp.Result.length > 0) {
            if (resp.Result.length === 1) {
              SetReportInfo(resp.Result[0])
              SetIsShowReportListBtn(false)
              SetIsShowShareBtn(true)
              this.$router.replace({ path: 'reportView',query: { id:resp.Result[0].ID } })
            } else {
              this.ReportInfos = resp.Result
              let CheckDates = []
              this.ReportInfos.forEach((item) => {
                if (!CheckDates.some((c) => c === this.moment(item.CheckDate).format('YYYY年MM月'))) {
                  CheckDates.push(this.moment(item.CheckDate).format('YYYY年MM月'))
                }
              })
              this.UIReportInfos = []
              CheckDates.forEach((item) => {
                this.UIReportInfos.push({
                  CheckDate: item,
                  Reports: this.ReportInfos.filter((r) => this.moment(r.CheckDate).format('YYYY年MM月') === item),
                })
              })
            }
          } else {
            this.$notify({ type: 'warning', message: resp.Message ? resp.Message : '没有查询到当前患者的报告数据！' })
            
          }
          setTimeout(() => {
            this.loadingSohw = false
          }, 1000)
        })
        .catch((err) => {
          console.log(err)
          this.loadingSohw = false
        })
    },
    //浏览报告数据
    handleReportInfoScan(data) {
      SetReportInfo(data)
      SetIsShowReportListBtn(true)
      SetIsShowShareBtn(true)
      this.$router.push({ path: '/reportView',query: { id:data.ID } })
    },
    GetAgeText(Birthday) {
      return GetAgeText(Birthday, 3)
    },
    GetSexText(sex) {
      return GetSexText(sex)
    },
  },
}
</script>
<style scoped>
.one {
  /* width: 98%; */
  padding: 10px 20px;
  margin: 10px 0;
  margin-top: 0px;
  border-radius: 7px;
  box-shadow: 0 0 14px rgba(186, 195, 209, 0.5);
  background: #fff;
  position: relative;
  background-image: url(../../assets/main_top.png);
  background-size: 100% 83%;
  background-repeat: no-repeat;
}

.personal_im {
  display: flex;
  color: white;
  height: 40px;
}

.personal_im div {
  font-size: 18px;
  margin-right: 20px;
}

.one h2 {
  line-height: 30px;
}

.conter_bj {
  background: #fff;
  position: relative;
  left: 0;
}

.txt_content {
  font-size: 14px;
}

.conter_bj h2 {
  background: #eef1f5;
  padding: 10px 15px;
  font-size: 15px;
  font-weight: bold;
  border: 1px solid rgba(186, 195, 209, 0.5);
}

.box {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 90px;
  padding: 5px 10px;
  border: 1px solid rgba(227, 233, 243, 0.5);
}

.left {
  width: 20%;
  height: 70px;
  text-align: center;
  line-height: 60px;
  border-right: 1px solid #f2f4f6;
  font-size: 16px;
}

.right {
  width: 80%;
  height: 80%;
  text-align: left;
  /* line-height: 60px; */
  padding-left: 20px;
}

.right p {
  font-size: 14px;
  line-height: 18px;
  color: #71767c;
}
.right p:nth-child(2) {
  margin: 5px 0;
}
.right p:nth-child(2) span {
  margin-right: 10px;
}
.right h3 {
  font-size: 18px;
  /* line-height: 40px; */
}

.right h3 span:nth-child(1) {
  padding-right: 10px;
}

</style>
<style>
  .head {
  width: 70px;
  height: 70px;
  border: 1px solid green;
  border-radius: 50%;
  position: absolute;
  right: 20px;
  top: 10px;
  overflow: hidden;
}
.head img {
  height: 100%;
}
</style>